import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { EntityTag } from '@coin/shared/core/util-models';

@Component({
  selector: 'customer-position-list-item-tags',
  templateUrl: './position-list-item-tags.component.html',
  styleUrls: ['./position-list-item-tags.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PositionListItemTagsComponent {
  @Input() tags?: EntityTag[];
}
